<mat-accordion *ngIf="!project else projectMenuBlock" class="app-project-list-menu">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title class="menu-title">
        <span i18n>DESIGNS</span>
      </mat-panel-title>
      <app-help topic="ADD_PROJECT"></app-help>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <button class="app-block" mat-raised-button (click)="newProject()" i18n>NEW DESIGN</button>
      <app-project-list></app-project-list>
    </ng-template>
  </mat-expansion-panel>
</mat-accordion>

<ng-template #projectMenuBlock>
  <app-project-menu></app-project-menu>
</ng-template>
